import React, { Component, lazy, Suspense } from "react";
import PropTypes from "prop-types";

import routes from "../../../../../../../../routes";

import NavRoute from "../../../../../../../common/router/Route";
import { connect } from "../../../../../../../StateProvider";

import styles from "./viewBody.less";
import _ from "lodash";
import Loading from "../../../../../../../common/Loading";

// workaround: https://react.dev/reference/react/lazy
// cause bundle it has a lot of weight
const Records = lazy(() => import("../../../../../../../Records"));
const Cards = lazy(() => import("../../../../../../../Cards"));
const Calendar = lazy(() => import("../../../../../../../Calendar"));
const Reports = lazy(() => import("../../../../../../../Reports"));
const History = lazy(() => import("../../../../../../../History"));
const StatisticsData = lazy(() =>
  import("../../../../../../../../components/Statistics")
);

class ViewBody extends Component {
  static propTypes = {
    catalog: PropTypes.object,
    catalogId: PropTypes.string,
    scene: PropTypes.object,
    sceneId: PropTypes.string,
    viewId: PropTypes.string
  };

  render() {
    const {
      catalog,
      catalogId,
      scene,
      sceneId,
      viewId,
      openRecordsInModal,
      isWebForm,
      getFieldsToRender
    } = this.props;
    return (
      <div className={styles.container}>
        <NavRoute
          route={routes.records}
          render={props => {
            return scene && catalog ? (
              <Suspense fallback={<Loading />}>
                <Records
                  catalog={catalog}
                  catalogId={catalogId}
                  scene={scene}
                  sceneId={sceneId}
                  isWebForm={isWebForm}
                  viewId={viewId}
                  openRecordsInModal={openRecordsInModal}
                />
              </Suspense>
            ) : null;
          }}
        />
        <NavRoute
          route={routes.cards}
          render={props => {
            return scene && catalog ? (
              <Suspense fallback={<Loading />}>
                <Cards
                  catalog={catalog}
                  catalogId={catalogId}
                  scene={scene}
                  sceneId={sceneId}
                  viewId={viewId}
                />
              </Suspense>
            ) : null;
          }}
        />
        {this.props.calendarExists && (
          <NavRoute
            route={routes.calendar}
            render={props => {
              return scene && catalog ? (
                <Suspense fallback={<Loading />}>
                  <Calendar
                    catalog={catalog}
                    catalogId={catalogId}
                    scene={scene}
                    viewId={viewId}
                  />
                </Suspense>
              ) : null;
            }}
          />
        )}
        <NavRoute
          route={routes.reports}
          render={props => {
            return catalog ? (
              <Suspense fallback={<Loading />}>
                <Reports
                  catalog={catalog}
                  viewId={viewId}
                  sceneId={sceneId}
                  colsMode={this.props.colsMode}
                />
              </Suspense>
            ) : null;
          }}
        />
        <NavRoute
          route={routes.history}
          render={props => {
            return scene && catalog ? (
              <Suspense fallback={<Loading />}>
                <History
                  catalog={catalog}
                  sceneId={sceneId}
                  scene={scene}
                  viewId={viewId}
                  getFieldsToRender={getFieldsToRender}
                />
              </Suspense>
            ) : null;
          }}
        />
        <NavRoute
          route={routes.statistics}
          render={props => {
            return scene && catalog ? (
              <Suspense fallback={<Loading />}>
                <StatisticsData
                  scene={scene}
                  catalog={catalog}
                  viewId={viewId}
                />
              </Suspense>
            ) : null;
          }}
        />
      </div>
    );
  }
}

export default connect(
  ViewBody,
  {
    scenes: ["scenes"],
    catalogs: ["catalogs"],
    userSettings: ["userSettings", "catalogs"]
  },
  (props, { scenes, catalogs, userSettings }) => {
    const scene = props.sceneId && scenes.get(props.sceneId);
    const catalog = props.catalogId && catalogs.get(props.catalogId);
    const sortField = userSettings.getIn([
      props.catalogId,
      "viewMode",
      "table",
      "sortingRecords",
      "sortField"
    ]);
    const sortType = userSettings.getIn([
      props.catalogId,
      "viewMode",
      "table",
      "sortingRecords",
      "sortType"
    ]);

    return {
      catalog,
      scene,
      sortType,
      sortField,
      ...props
    };
  }
);
